module.exports = __webpack_public_path__ + "static/media/warning.456bb38c.svg";